import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Header as FoundationsHeader } from 'foundations-components/transitional/components/Header';
import { Link } from 'foundations-components/transitional/components/Link';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Tabs as FoundationsTabs, Tab } from 'foundations-components/transitional/components/Tabs';
import { Flex } from 'foundations-components/components/Flex';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { isLegacyKBDeleted, isMigratedKBPublished } from 'knowledge-content-types/KnowledgeBaseV3Service/MigrationTypes';
import { NavMarker } from 'react-rhumb';
import { Tabs } from '../constants/TabConstants';
import { SCREENS } from '../constants/TrackingConstants';
import ContentKnowledgeBaseSwitcher from '../content-listing/components/ContentKnowledgeBaseSwitcher';
import KnowledgeBaseSwitcher from '../knowledge-base/components/KnowledgeBaseSwitcher';
import { useGetKnowledgeBaseLimitOverage } from '../knowledge-base/hooks/knowledgeBaseHooks';
import { selectCurrentKbMigrationReport } from '../knowledge-base/selectors/knowledgeBaseDetails';
import { getGlobalContentEditorUrl, getThemeSettingsEditorUrl } from '../routing/utils/externalUrls';
import { getArticlesStatePath, getInsightsDashboardPath, getOrganizePath, getSuggestionsPath } from '../routing/utils/internalPaths';
import { getIsUngatedForThemeSettingsVariant } from '../selectors/gates';
import TourStepWithProgress from '../tour/components/TourStepWithProgress';
import { CONFIGURE_STEP, CREATE_ARTICLE_STEP, INSIGHTS_STEP } from '../tour/config/NewUserOnboardingTourConfig';
import UsageTracker, { beforeUnloadTracker } from '../utils/UsageTracker';
import { useAppSelector } from '../utils/hooks';
import CreateArticleButton from './CreateArticleButton';
import MissingPermissionsTooltip from './MissingPermissionsTooltip';
import MigrationAlert from './migration/MigrationAlert';
import { getIsUngatedForKBAgent } from '../selectors/gates';
import { Box } from 'foundations-components/transitional/components/Box';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import SeatRequiredAlert from './SeatRequiredAlert';
import { useIsMissingServiceSeat } from '../auth/hooks/seatHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Header = ({
  knowledgeScopes: {
    canEditAdminSettings,
    canEditCategories
  },
  onRouteChange,
  selectedTab,
  knowledgeBase,
  screen
}) => {
  const kbMigrationReport = useAppSelector(selectCurrentKbMigrationReport);
  const isUngatedForKBAgent = useAppSelector(getIsUngatedForKBAgent);
  const isMigratedKBv3 = !!kbMigrationReport;
  const showMigrationAlert = isMigratedKBv3 && !isMigratedKBPublished(kbMigrationReport.migration.status);
  const showSeatsAlert = useIsMissingServiceSeat();

  // @ts-expect-error - scpValues should be defined since we're in V3 codepath
  const scpValues = knowledgeBase.scpValues;
  const isUngatedForThemeSettingsVariant = useAppSelector(getIsUngatedForThemeSettingsVariant);
  const {
    isOverLimit
  } = useGetKnowledgeBaseLimitOverage();
  const handleOrganizeClick = () => {
    UsageTracker.track('manageArticleInteraction', {
      screen: SCREENS.MANAGE,
      action: 'configure-categories-click'
    });
    onRouteChange(getOrganizePath());
  };
  const handleCustomizeTemplateClick = () => {
    const {
      additionalLanguages
    } = knowledgeBase;
    beforeUnloadTracker.track('manageArticleInteraction', {
      screen: SCREENS.MANAGE,
      action: 'customize-template-click'
    });
    window.location.href = getThemeSettingsEditorUrl(isUngatedForThemeSettingsVariant ? scpValues.hs_id : scpValues.hs_theme_settings_id, scpValues.hs_name, scpValues.hs_language, additionalLanguages, scpValues.hs_business_unit_id);
  };
  const cmpTabs = /*#__PURE__*/_jsxs(FoundationsTabs, {
    onSelectedChange: event => {
      switch (event.target.value) {
        case Tabs.manage:
          onRouteChange(getArticlesStatePath());
          break;
        case Tabs.analyze:
          onRouteChange(getInsightsDashboardPath());
          break;
        case Tabs.kbAgent:
          onRouteChange(getSuggestionsPath());
          break;
        default:
          onRouteChange(getArticlesStatePath());
      }
    },
    selected: selectedTab,
    children: [/*#__PURE__*/_jsx(Tab, {
      tabId: Tabs.manage,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `knowledgeContentUI.tabs.${Tabs.manage}`
      })
    }), /*#__PURE__*/_jsx(Tab, {
      tabId: Tabs.analyze,
      title: /*#__PURE__*/_jsx(TourStepWithProgress, {
        stepKey: INSIGHTS_STEP,
        content: {
          header: /*#__PURE__*/_jsx("h4", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.onboardingTour.insights.title"
            })
          }),
          body: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.onboardingTour.insights.body"
          }),
          footer: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.onboardingTour.insights.buttonText"
          })
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `knowledgeContentUI.tabs.${Tabs.analyze}`
        })
      })
    }), isUngatedForKBAgent && /*#__PURE__*/_jsx(Tab, {
      tabId: Tabs.kbAgent,
      onClick: () => {
        UsageTracker.track('kbAgentView', {
          screen: SCREENS.KB_AGENT_DASHBOARD,
          action: 'view-suggestions-tab-click'
        });
      },
      title: /*#__PURE__*/_jsxs(Flex, {
        gap: "200",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `knowledgeContentUI.tabs.${Tabs.kbAgent}`
        }), /*#__PURE__*/_jsx(AIBadge, {})]
      })
    })]
  });
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "V3_HEADER_RENDERED",
    children: /*#__PURE__*/_jsxs(FoundationsHeader, {
      flush: true,
      marginBlockEnd: "0",
      tabs: cmpTabs,
      title: /*#__PURE__*/_jsx(Flex, {
        children: /*#__PURE__*/_jsx(Box, {
          alignSelf: "end",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.shared.knowledge"
          })
        })
      }),
      details: /*#__PURE__*/_jsxs(_Fragment, {
        children: [showSeatsAlert && /*#__PURE__*/_jsx(SeatRequiredAlert, {}), showMigrationAlert && /*#__PURE__*/_jsx(MigrationAlert, {
          screen: screen
        }), screen === SCREENS.MANAGE ? /*#__PURE__*/_jsx(ContentKnowledgeBaseSwitcher, {}) : /*#__PURE__*/_jsx(KnowledgeBaseSwitcher, {
          isCmpEnabled: true
        })]
      }),
      children: [isMigratedKBv3 && !isLegacyKBDeleted(kbMigrationReport.migration.status) && /*#__PURE__*/_jsx(Link, {
        onClick: () => onRouteChange(getArticlesStatePath(kbMigrationReport.legacyKnowledgeBase.id)),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3MigrationPublish.legacyLink.linkText"
        })
      }), /*#__PURE__*/_jsx(TourStepWithProgress, {
        stepKey: CONFIGURE_STEP,
        content: {
          header: /*#__PURE__*/_jsx("h4", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.onboardingTour.configurationOptions.title"
            })
          }),
          body: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.onboardingTour.configurationOptions.body"
          }),
          footer: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.onboardingTour.configurationOptions.buttonText"
          })
        },
        children: /*#__PURE__*/_jsx(Dropdown, {
          "data-test-id": "configure-dropdown",
          buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.configure.label"
          }),
          buttonUse: "secondary",
          buttonSize: "small",
          children: /*#__PURE__*/_jsxs(List, {
            wrapChildren: true,
            children: [/*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsx(MissingPermissionsTooltip, {
                shouldShowTooltip: !canEditAdminSettings,
                placement: "left",
                children: /*#__PURE__*/_jsx(Button, {
                  disabled: !canEditAdminSettings || isOverLimit,
                  onClick: handleCustomizeTemplateClick,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "knowledgeContentUI.configure.theme"
                  })
                })
              })
            }), /*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsx(MissingPermissionsTooltip, {
                shouldShowTooltip: !canEditAdminSettings,
                placement: "left",
                children: /*#__PURE__*/_jsx(Button, {
                  disabled: !canEditAdminSettings || isOverLimit,
                  onClick: () => {
                    if (scpValues) {
                      beforeUnloadTracker.track('manageArticleInteraction', {
                        screen: SCREENS.MANAGE,
                        action: 'configure-header-click'
                      });
                      window.location.href = getGlobalContentEditorUrl(isUngatedForThemeSettingsVariant ? scpValues.hs_id : scpValues.hs_theme_settings_id, 'header');
                    }
                  },
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "knowledgeContentUI.configure.header"
                  })
                })
              })
            }), /*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsx(MissingPermissionsTooltip, {
                placement: "left",
                shouldShowTooltip: !canEditAdminSettings,
                children: /*#__PURE__*/_jsx(Button, {
                  disabled: !canEditAdminSettings || isOverLimit,
                  onClick: () => {
                    if (scpValues) {
                      beforeUnloadTracker.track('manageArticleInteraction', {
                        screen: SCREENS.MANAGE,
                        action: 'configure-footer-click'
                      });
                      window.location.href = getGlobalContentEditorUrl(isUngatedForThemeSettingsVariant ? scpValues.hs_id : scpValues.hs_theme_settings_id, 'footer');
                    }
                  },
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "knowledgeContentUI.configure.footer"
                  })
                })
              })
            }), /*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsx(MissingPermissionsTooltip, {
                shouldShowTooltip: !canEditCategories,
                placement: "left",
                children: /*#__PURE__*/_jsx(Button, {
                  "data-test-id": "organize-categories",
                  disabled: !canEditCategories || isOverLimit,
                  onClick: handleOrganizeClick,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "knowledgeContentUI.configure.categories"
                  })
                })
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsx(TourStepWithProgress, {
        stepKey: CREATE_ARTICLE_STEP,
        content: {
          header: /*#__PURE__*/_jsx("h4", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.onboardingTour.createArticle.title"
            })
          }),
          body: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.onboardingTour.createArticle.body"
          }),
          footer: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.onboardingTour.createArticle.buttonText"
          })
        },
        children: /*#__PURE__*/_jsx(CreateArticleButton, {})
      })]
    })
  });
};
export default Header;